<template>
  <span
    :class="{
      'inline-block': true,
    }"
  >
    <PtcPicture
      v-if="image.asset"
      provider="sanity"
      format="webp"
      :src="image.asset._ref"
      :alt="image.altText"
      :img-attrs="{ class: { 'w-5': true } }"
      :modifiers="{ crop: image.crop, hotspot: image.hotspot }"
      loading="lazy"
    />
  </span>
</template>

<script setup lang="ts">
import type { InlineImageAtom } from '~/sanity/types';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
defineProps<InlineImageAtom>();
</script>

<style scoped></style>
